<ng-container *ngIf="manager$ | async as manager">
  <div class="cpp-business-card" id="card-{{id}}">
    <h3 class="cpp-business-card__title">{{this.header}}</h3>
    <span class="cpp-business-card__image">
      <img src="../../../../../assets/images/u4-logo.svg" alt="Unit4" />
    </span>
    <div class="cpp-business-card__details">
      {{manager.name}}<br/>
      <a href="mailto:{{manager.email}}">{{manager.email}}</a>
      <ng-container *ngIf="manager.phoneNumber">
        <br/><a href="tel:{{manager.phoneNumber}}">{{labels['usermanagement.phone-number-prefix']}} {{manager.phoneNumber}}</a>
      </ng-container>
      <ng-container *ngIf="manager.mobilePhoneNumber">
        <br/><a href="tel:{{manager.mobilePhoneNumber}}">{{labels['usermanagement.mobile-phone-number-prefix']}} {{manager.mobilePhoneNumber}}</a>
      </ng-container>
    </div>
    <p><a href="{{this.linkFooter}}">{{this.footer}}</a></p>
  </div>
</ng-container>

<ng-container *ngIf="noManager$ | async">
  <div class="cpp-business-card" id="card-{{id}}">
    <h3 class="cpp-business-card__title">{{this.header}}</h3>
    <p><a href="{{this.linkFooter}}">{{this.footer}}</a></p>
  </div>
</ng-container>

